var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavigationBar'),_c('Science'),_c('DownloadLinks'),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }